import { api } from '@/lib/api';

export type AccessMemberStatus = 'invited' | 'registered' | 'revoked' | 'requested';

export interface AccessMemberRow {
  id: string;
  email: string;
  status: AccessMemberStatus;
  invitedAt?: string;
  lastInvitedAt?: string | null;
  resendCount?: number;
  registeredAt?: string | null;

  // computed by backend listMembers
  surveySends?: number;
  lastSurveySentAt?: string | null;
  surveyResponses?: number;
  lastSurveyImportedAt?: string | null;
}

export interface SurveyResponseRow {
  id: string;
  email: string;
  submittedAt?: string | null;
  sheetRowId?: string | null;
  raw: any;
  importedAt: string;
}

export const accessService = {
  async listMembers(status?: AccessMemberStatus): Promise<AccessMemberRow[]> {
    const response = await api.get<AccessMemberRow[]>('/access/members', {
      params: status ? { status } : undefined,
    });
    return response.data;
  },

  async invite(email: string) {
    const response = await api.post('/access/members/invite', { email });
    return response.data;
  },

  async resend(email: string) {
    const response = await api.post('/access/members/resend', { email });
    return response.data;
  },

  async revoke(email: string) {
    const response = await api.post('/access/members/revoke', { email });
    return response.data;
  },

  async sendSurvey(email: string, formUrl?: string) {
    const response = await api.post('/access/survey/send', { email, formUrl });
    return response.data as { success: boolean; message: string };
  },

  async getResponses(email: string) {
    const response = await api.get<{ email: string; responses: SurveyResponseRow[] }>(
      '/access/survey/responses',
      { params: { email } },
    );
    return response.data;
  },

  async importResponse(data: {
    email: string;
    raw: Record<string, any>;
    submittedAt?: string;
    sheetRowId?: string;
  }) {
    const response = await api.post('/access/survey/responses/import', data);
    return response.data;
  },

  async listRequests(): Promise<AccessMemberRow[]> {
    const response = await api.get<AccessMemberRow[]>('/access/members/requests');
    return response.data;
  },

  async approveRequest(email: string) {
    const response = await api.post('/access/members/approve', { email });
    return response.data;
  },

  async denyRequest(email: string) {
    const response = await api.post('/access/members/deny', { email });
    return response.data;
  },
};

